<ul>
  <li>
    <p>
      <span
        ><span style="color: #00b0f0;"><span><span lang="en-GB"><strong>Target</strong></span></span></span><span style="color: #00b0f0;"
          ><span><span lang="en-GB">: </span></span></span
        ><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >If YTD is selected: Target for Bolus churn rate p.m. for the current year (= target for annual Bolus churn rate / 12). Else:
              Target for Bolus churn rate p.a. in the year of the selected timeframe.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span
        ><span style="color: #404040;"><span><span lang="en-GB"><strong>Actual</strong></span></span></span><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >: If YTD is selected: Average actual Bolus churn rate p.m. (based on all months YTD). Else: Bolus churn rate p.a.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span style="color: #92d050;">●</span><span
        ><span style="color: #404040;"><span><span lang="en-GB">/</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">: The icon indicates whether the target is met (</span></span></span><span
          style="color: #92d050;"><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">) or missed (</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"><span><span lang="en-GB">)</span></span></span></span
      >
    </p>
  </li>
</ul>
<p lang="en-GB">&nbsp;</p>
<p>
  <em>Calculation of the Bolus churn rate</em><em
    >: Total number of active boluses of "churn" customers (customers, that cancelled their subscription within a specific period e.g. one
    month) / Total number of active boluses at the beginning of the same period e.g. one month.</em
  >
</p>
<p lang="en-GB">&nbsp;</p>
<p>Chart:</p>
<p>
  <img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAHCAYAAACC5PR5AAAAMElEQVR4nGPZ//q3w45XfzwYBgFgOfH+r0Xn7Z/lA+0QEGAZaAcgg1HH4AKjjsEFAGiKC6hW9SILAAAAAElFTkSuQmCC"
    alt=""
  />&nbsp; &nbsp;Target for bolus churn rate p.m. (=annual target/12)
</p>
<div class="p" style="position: relative;">
  &nbsp; &nbsp;&nbsp;<img
    style="top:6px; left:2px; height:7px; position: absolute;"
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAABXUlEQVR4nGP5//8/Ay5w+fodW11NlcPY5Fhwadqw/UDu1HmrJ2UnheYFeDpMJkrjnkOnYqfNXzMRxAbRPNxcH1zszBbj1Xj8zCW/7qmL5wO9wAjig2gQn5uL46Olid4mrBovXLnp1NQ7d/W/f/+YkcVBfJB4e3WWp4GO+j4UjTduPzCv65y58c+fP2zYnA8SB8l31eW5aKgqnARrvP/omW51+7St33/85MGmCQZA8iB1PQ0FjizPXrxWqWqduv3T56/C+DTBAEgdSD3O6CAEWKQkRO+0VWd7ljRM2E+MrXy83G9B6sE2KspJXW6tzPIua5q0B58/OTnYv4DUgdTDnQoKqabydP/K1mnbsYUsCwvLL5A8SB2YjywJiqO64uTQhu7Z65DjkomJ6S9IHBaHGBpBAJQ6SrNjE7umLFoISjVA8B/ER041WDWCAChdfvn6TQCUyLMSQ/LR0ykIAACawqr1XnW92AAAAABJRU5ErkJggg=="
    alt=""
  /><img
    style="left: 0; top: 50%; width:15px; position: absolute;"
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAHCAYAAACC5PR5AAAAdUlEQVR4nO3OPQqAMAyG4bZEtCKIN/UW3sLJTXBx81pqbUN/pKAQCs5dfMaPEF4wiBWikeyB1pYGTc0I52xxad3QzYcgTqValjjU0aVbvAvBC7rFf9a5gm6wbGs/ztOQPsgBcgdQf8wXqCu55454Aefc54543cE4LazsQsZFAAAAAElFTkSuQmCC"
    alt=""
  />&nbsp; Bolus churn rate per month
</div>

<p>
  <img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAHCAYAAABtJp9HAAAAcUlEQVR4nGO5cP2yw5nL5z0YsAAfR/cZ4iJiD9DFf/3+zbF4w4oGbHpkJaVvuNk4LcAmd+zcyYDrd29ZYJNjAUms3Lq+HJukub7JFmwO+f3nNztuPcZbcTnk7JWLbpv37cjE6hBsggMBRh2CDkYdgg4A+skqv1R38JsAAAAASUVORK5CYII="
    alt=""
  />&nbsp; &nbsp;Average bolus churn rate in selected year (YTD or p.a.)
</p>
<p>
  <img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAHCAYAAACC5PR5AAAAQUlEQVR4nGP5+PGjxYcPH+wZiAQsLCzviVXLzMz8nYmJ6QeRyv+zAB3icO/evXZiLaAlYBloByCDUcfgAqOOwQUA2PIQYPdeSvEAAAAASUVORK5CYII="
    alt=""
  />&nbsp; &nbsp; Bolus churn rate per month of prev. year
</p>
<p>
  <img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAHCAYAAABkzT89AAAAm0lEQVR4nGP5+PGjxYcPH+wZsAAREZH1XFxct7DJPXv2LPPPnz98yGKMjIz/WFlZX0tISCzApufHjx9y796988Amx8PDc4GPj+8UjM8CdJTDvXv32rEp5ubmvoLLYQ8fPqz4+fOnHLo4CwvLR1wO+/r1q+6tW7dmYpOTk5PrQHEYNkWDAYwchwHT2W9qmEN1hzExMX2jhjmDNioBSL8zRBx0t2QAAAAASUVORK5CYII="
    alt=""
  />&nbsp;&nbsp; Average bolus churn rate in previous year
</p>
<p>
  <img
    style="height: 12px;"
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAfCAYAAACoE+4eAAAEQElEQVR4nN2Ye0zTVxTHvy0tpVQeAspg6BhSNKKgxsU5ndHFGZepMzrjHiYm/uFrU6PGx1yi0UTntkwz3abzjyVLnM74yKYuGjXT4GtmZpNnECqoFBARpGgf9PXbPVepQtvb9tcKjE9yk/bX3/nd87333HPOrypJkiDEaUqAvT4NsUPKxTf2DFTCXyV7NEpnHYP15mDkX5gIbbahi/ySjUCQpED5gp/Q8udb/GvR5HMYcWk8NBnGLvJNFv4FVW/Yhvu/fOz5brvzCgonneeiolMbusI5OfgWVLdnCe5uX+913WrIRtHbZ5HPdk2d8uBFOycHb0FNx2fAsGy3Xwtz8XAUv3MKeecmQ5VgCjgDncOG/fPQeHQ2cvYthObl2rA8DkBHQa3XxqDsw4OQXFFCq0fXR6Pk3T+Qd2YKlLEWn/e4zDrUMwHGHavQZszg126Mv8RttPrKyLjvzTNBbXcHomT6CbgtsUFZmi6PQ8l7v2PYyWlQato8153NSajdvYwPR1NyBxvb7UzcmFCA4aenok9+YWQkdOSJIKo1xdNOwtHYLyTrhyzsyuYcRu6R92FntrQbtCuux3382tjvvYTCiRf4QiSMuxyW9z5QeWoNnQ05NJ2YjgK2Q4ooV8BQbcfZkoiiKWeQy85V0tTTsub1gwp1exd7ao1PFBLUSc1e4dOZYMW0Q6FNITvk5/no/8GvIdkKUMEV4MxkrNyJ5BnHcXvjFpgKJkRqYg5FR/m8/XCxkE9b9GMkHilufXR5RUiZ+Rv/nLlpM6o/34rWv16PxMQeaGcrluyBgyWTgZ99Ee7jxILSF+7zfFaoHcjcshFV67fj8T+jgnt6fCtSZh+FOrkJxm9XQHKofd/I2izqTJwP+yLry3U8zGUiFtQZZYwNWds2wLBqByxlQ/3ep+7XiP5zD/FQJRsiOq2e77DbFuPXrubrNXyMZCUh7rW/+SKGSGiCCCqkg75ZDcPyXbBW6jv8phlQg9SPDqAvy2CdnSEHB+1ciaq1X8H1KE44x78snSu1VsSNvo74N64ggY34sVf5QkVcEBGlM3tEUbHU5lQglR3uRFY0oXT7tdPllkLPCi7tMBVgEW6rFqaLb/JR8/QazUPCuEA2dEPLOs8nTxC3TGzhokgQrX6wxGRVQf/9J7jFRNGLYyhYK3L4aGCpnvvAekkSyAeJHHNNviCCQiCIMPCCGlT9D0u5KFv1q7Lnpw6nmbVRNAhW3MMTFA6U+Sj8brEzJUowocBKQPcJIqJYWs9miYLevVqvjhVmwCDpXkEEZbPMzZt4gaUXSEvJMJhLc3lvaW9IDfVx3S+oHWpuYwff5IOKMUHdv5kEPhVJCUFyCn3uOYJ8QQkncdJ5Pgh3m4b/A1X56Xe+7095IBZkYSuieO7lrScg8keTYRQLqt21PNL+vFACCvq/EZ1e17sE9bod6n2CBtT0MkHpdf8BzbKSJMiL1FIAAAAASUVORK5CYII="
    alt=""
  />&nbsp; &nbsp;Herd churn rate p.m.
</p>
<p>
  <img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAHCAYAAABOfc6SAAAAzklEQVR4nGP5//O5BMPPp9IM2ACX+k0GZp4vWOXe73HBEPv3jYuBmfczg4Djfqx6vt3QYPh6WZfhz0d+oGImFDkhjx0M7HKPsOp73F2KoR4E2GWesDC8WJDAcL+yHatGg8O2DPw2R7DKXXLdjVUcpB6kDxt4syEAp126W3xweuBRazXE05h2sWDVAAOgEB3M4O83Lvwe+P+bFaccI/Nfhv9/mantJpIA0H34PYAPgPIGtmj9/4d8M8kA1Lfs71duqpuJB9A1tBiYub9S20gA4NRB/oNaX3IAAAAASUVORK5CYII="
    alt=""
  />&nbsp; &nbsp; Average herd churn rate in selected year (YTD or p.a.)
</p>
<p lang="en-GB">&nbsp;</p>
<p style="margin-bottom: 10px;">
  <em>Calculation of Herd churn rate</em><em
    >: Total number of MaxInstallations of "churn" customers (customers, that cancelled their subscription within a specific period, e.g.
    one month) in the month of the cancellation / Total number of active boluses at the beginning of the month.</em
  >
</p>

<style>
  p {
    padding: 0;
    margin: 0;
  }

  img {
    width: 11px;
    height: 2px;
  }
</style>
